import { createGlobalStyle } from 'styled-components';
import type theme from '@/theme';
import { device } from './helpers';

import 'rc-tooltip/assets/bootstrap_white.css';

export const GlobalStyles = createGlobalStyle<{ theme: typeof theme }>`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  body {
    background-color: ${({ theme }) => theme.blackColor};
    color: ${({ theme }) => theme.whiteColor};
  }

  #chatra:not(.chatra--expanded) {
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none;
  }


  .close {
    color: ${({ theme }) => theme.blackColor};
  }

  #root {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 100vh;
  }

  input, button, textarea {
    font-family: inherit;
		border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    &:focus {
      outline: none
    }
  }

  img {
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.secondaryColor};
  }

	*:focus,
	*:active {
		-webkit-tap-highlight-color: rgba(0,0,0,0);
	}

  .tournament-iframe {
    @media(${device.mobileS}) {
      overflow-x: auto;
      iframe {
        min-width: 450px;
      }
    }
  }

  .intercom-namespace .intercom-messenger-frame {
    bottom: 36px !important; //intercom chat widget position with casino clock
  }
`;
